export const productsList = [{
    id: 0,
    title: 'TRUPER Rotomartillo Profesional, 1/2” - 650w',
    description : 'Rotomartillo con motor de 650w, mango con giro de 360° y varilla d...',
    currency: '+IVU',
    price: '$51.20',
    imageId: 'AA01'
},{
    id: 2,
    title: 'ENERGIZER Generador silencioso - 4500w',
    description : 'La Energizer eZV4500i fue diseñada para eliminar la molestia de alim...',
    currency: '+IVU',
    price: '+$1099.00',
    imageId: 'AA02'
},{
    id: 3,
    title: 'GLY-STAR PLUS Herbicida, 2.5 Galones',
    description : '1x$70.00 - 2x$134.50',
    currency: '+IVU',
    price: '$70',
    imageId: 'AA03'
},
]